const STORAGE_KEY = 'material-list-scroll';
const MAX_RESTORED_PAGES = 10;

// Also the grid query gcTime: a restore only pays off while the cached pages are alive
export const SCROLL_RESTORE_MAX_AGE_MS = 30 * 60 * 1000;

type SavedScroll = { scrollY: number; pages: number };
type StoredScroll = SavedScroll & { url: string; savedAt: number };

export function saveScroll(loadedPages: number, url: string) {
  try {
    const entry: StoredScroll = { scrollY: window.scrollY, pages: loadedPages, url, savedAt: Date.now() };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    return;
  }
}

export function takeSavedScroll(url: string): SavedScroll | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!raw) return undefined;
    const entry: StoredScroll = JSON.parse(raw);
    if (entry.url !== url || Date.now() - entry.savedAt >= SCROLL_RESTORE_MAX_AGE_MS) return undefined;
    if (!(entry.scrollY >= 0) || !(entry.pages >= 1)) return undefined;
    return { scrollY: entry.scrollY, pages: Math.min(entry.pages, MAX_RESTORED_PAGES) };
  } catch {
    return undefined;
  }
}
